export const UPDATE_PREDICTION_POINTS_POST = 'UPDATE_PREDICTION_POINTS_POST';
export const UPDATE_PREDICTION_POINTS_SUCCESS = 'UPDATE_PREDICTION_POINTS_SUCCESS';
export const UPDATE_PREDICTION_POINTS_FAIL = 'UPDATE_PREDICTION_POINTS_FAIL';

export const GET_LEADERS_POINT_FETCH = 'GET_LEADERS_POINT_FETCH';
export const GET_LEADERS_POINT_FETCH_SUCCESS = 'GET_LEADERS_POINT_FETCH_SUCCESS';
export const GET_LEADERS_POINT_FETCH_FAIL = 'GET_LEADERS_POINT_FETCH_FAIL';